//Imports
import Vue from 'vue';
import '@/registerServiceWorker';
import '@/config/globalComponents/index'; // GlobalComponents
import '@/config/veeValidate/index'; // VeeValidate
import '@/config/vueTelInput/index'; // Telephone Input
import '@/config/vueSanitize/index'; // vueSanitize
import '@/config/vmodal/index'; // Modal
import '@/config/sentry/index'; // Sentry
import VueGtag from 'vue-gtag';
import i18n from '@/config/i18n/index';
import dayjs from '@/config/dayjs/index'; // DayJS
import store from './store/index'; // Store
import router from './router/index'; // Router
import App from './App.vue';
import { setAuthHeader } from '@/config/axios/index';
import { currentRealm } from '@/utils/realm.js';
import { vMaska } from 'maska/vue';

// --- Prototype
Vue.prototype.$dayjs = dayjs;
Vue.prototype.currentRealm = currentRealm;

let analyticsCity = process.env.VUE_APP_ANALYTICS_GTAG_CITY ?
  { id: process.env.VUE_APP_ANALYTICS_GTAG_CITY } :
  {};

Vue.directive('maska', vMaska);

Vue.use(
  VueGtag,
  {
    includes: [analyticsCity],
    config: { id: process.env.VUE_APP_ANALYTICS_GTAG }
  }
);

Vue.config.productionTip = false;

new Vue({
  name: 'AppVue',
  router,
  store,
  i18n,

  async created() {
    if (store.getters.userIsLogged) {
      setAuthHeader(store.getters.userToken);
      await store.dispatch('initKeycloak', 'check-sso');
    } else {
      await store.dispatch('initKeycloak');
    }
  },
  render: (h) => h(App)
}).$mount('#app');

